'use client';

import { motion } from 'framer-motion';
import { Headset, Landmark, ShieldCheck } from 'lucide-react';

const ITEMS = [
 
  {
    icono: Landmark,
    titulo: 'Gobernación de Risaralda',
    detalle: `© ${new Date().getFullYear()} · Todos los derechos reservados`,
  },
];

// Franja institucional del pie: siempre visible, discreta sobre la fotografía.
export default function LoginFooter() {
  return (
    <motion.footer
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 0.5, delay: 0.85, ease: 'easeOut' }}
      className="relative z-10 border-t border-white/10 px-5 py-4 sm:px-8"
    >
      <div className="flex flex-col items-center gap-3 text-center sm:flex-row sm:justify-center sm:gap-10 sm:text-left">
        {ITEMS.map(({ icono: Icono, titulo, detalle }) => (
          <div key={titulo} className="flex items-center gap-2.5 text-white/75">
            <Icono className="size-4 shrink-0 text-white/60" />
            <p className="leading-tight">
              <span className="block text-xs font-semibold text-white/90">{titulo}</span>
              <span className="block text-[11px] text-white/60">{detalle}</span>
            </p>
          </div>
        ))}
      </div>
    </motion.footer>
  );
}
